/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LegalFormType {
    PARTNERSHIP = 'partnership',
    COMPANY = 'company',
    TRUST = 'trust',
    PASSTHROUGH = 'passthrough',
    OTHER = 'other',
}
